(() => {
  const ROT_STEPS = [-15,-10,-5, 5,10,15];
  const TILE_K = 0.073125;
  const LR_IJ    = String.fromCodePoint(0x0133); // ij ligature
  const LR_IJ_UP = String.fromCodePoint(0x0132); // IJ ligature
  const LR_STACK_MQ = "(max-width: 900px) and (orientation: portrait), (max-width: 665px) and (orientation: landscape)";

  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  const qs = (k) => new URLSearchParams(location.search).get(k);
  const debounce = (fn, ms=120) => {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  };
  const num = (pxString) => parseFloat(pxString) || 0;

  function parseAspect(boardEl) {
    const fallback = 1276 / 1140;
    if (!boardEl) return fallback;
    const ar = getComputedStyle(boardEl).aspectRatio;
    if (!ar) return fallback;
    if (ar.includes("/")) {
      const parts = ar.split("/").map(s => parseFloat(s.trim()));
      if (parts.length === 2 && parts[0] > 0 && parts[1] > 0) return parts[0] / parts[1];
      return fallback;
    }
    const asNum = parseFloat(ar);
    return (asNum && isFinite(asNum)) ? asNum : fallback;
  }

  // PATCH B: enforce font on ghost elements appended outside modal
  function patchGhostFonts(el) {
    if (!el) return;
    el.style.setProperty("font-family", "var(--lr-font-family)", "important");
    const g = el.querySelector(".lr-glyph");
    if (g) g.style.setProperty("font-family", "var(--lr-font-family)", "important");
  }

  let ghostObserver = null;
  function startGhostObserver() {
    if (ghostObserver) return;
    const body = document.body || document.documentElement;
    ghostObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.classList.contains("lr-ghost")) patchGhostFonts(n);
          n.querySelectorAll?.(".lr-ghost")?.forEach(patchGhostFonts);
        });
      }
    });
    ghostObserver.observe(body, { childList: true, subtree: true });
  }
  function stopGhostObserver() {
    if (ghostObserver) { ghostObserver.disconnect(); ghostObserver = null; }
  }

  function parseConfig() {
    const el = $("#lr-config");
    if (!el) throw new Error("lr-config ontbreekt");
    return JSON.parse(el.textContent || "{}");
  }

  const DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  function safeGetItem(key) {
    try { return localStorage.getItem(key); } catch { return null; }
  }
  function safeSetItem(key, value) {
    try { localStorage.setItem(key, value); } catch {}
  }
  function safeRemoveItem(key) {
    try { localStorage.removeItem(key); } catch {}
  }

  function lockScroll(on) { document.body.classList.toggle("lr-noscroll", on); }

  // sync --lr-key-size from current tile size (one-way)
  function syncKeySizeVar() {
    const modal = document.getElementById('lr-modal');
    if (!modal || !modal.classList.contains('is-open')) return;
    const styles = getComputedStyle(modal);
    const tileSize = parseFloat(styles.getPropertyValue("--lr-tile-size")) || 0;
    if (!tileSize || !isFinite(tileSize)) return;
    modal.style.setProperty('--lr-key-size', `${tileSize}px`);
    const keyFont = tileSize * 0.62;
    modal.style.setProperty('--lr-key-font', `${keyFont}px`);
  }

  function median(arr){
    const a = [...arr].sort((x,y)=>x-y);
    return a[Math.floor(a.length/2)];
  }

  function isLoveRockPage() {
    return !!document.getElementById("lr-config");
  }

  function findLoveRockActions(lrBtn) {
    const candidates = Array.from(document.querySelectorAll(".actions"));
    if (!candidates.length) return null;
    if (lrBtn) {
      const near = lrBtn.closest(".actions");
      if (near) return near;
    }
    const withCart = candidates.find(a => a.querySelector(".action-list.addtocart"));
    return withCart || candidates[0];
  }

  function applyLoveRockActionsFix() {
    if (!isLoveRockPage()) return false;
    const lrBtn = document.getElementById("lr-open");
    if (!lrBtn) return false;
    const actions = findLoveRockActions(lrBtn);
    if (!actions) return false;

    const addWrap =
      actions.querySelector(".action-list.addtocart .button-wrapper-content") ||
      actions.querySelector(".action-list.addtocart");
    if (!addWrap) return false;

    const wishlist = actions.querySelector(".action-list.wishlist");
    if (wishlist) wishlist.remove();

    const findCartBtn = () => {
      const sel = [
        "#printlane-button",
        ".action-list.addtocart button[name=\"add\"].btn-cart",
        ".action-list.addtocart button.btn-cart",
        "button[name=\"add\"].btn-cart",
        "button.btn-cart"
      ];
      for (const s of sel) {
        const btn = actions.querySelector(s);
        if (btn && btn !== lrBtn) return btn;
      }
      return null;
    };

    const cartBtn = findCartBtn();
    const alreadyPlaced = addWrap.contains(lrBtn) && !cartBtn;
    if (!cartBtn && !alreadyPlaced) return false;

    const span = lrBtn.querySelector("span");
    if (span) span.textContent = "Personaliseer";
    else lrBtn.textContent = "Personaliseer";
    lrBtn.type = "button";
    lrBtn.style.borderRadius = "0";
    if (cartBtn && cartBtn.className) {
      lrBtn.className = `${cartBtn.className} lr-open-btn`.trim();
    }
    lrBtn.classList.remove("add-to-cart", "btn-cart");

    if (alreadyPlaced) return true;

    if (lrBtn.parentNode && lrBtn.parentNode !== addWrap) {
      lrBtn.parentNode.removeChild(lrBtn);
    }

    if (cartBtn && cartBtn.parentNode) {
      cartBtn.replaceWith(lrBtn);
    } else {
      addWrap.appendChild(lrBtn);
    }

    return true;
  }

  function setupLoveRockActionsObserver() {
    if (!isLoveRockPage()) return;
    if (window.__lrActionsObserver) return;
    document.body.classList.add("lr-love-rock-page");

    let scheduled = false;
    const run = () => { scheduled = false; applyLoveRockActionsFix(); };

    const obs = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(run);
    });

    obs.observe(document.body, { childList: true, subtree: true });
    window.__lrActionsObserver = obs;
    applyLoveRockActionsFix();
  }

  function calcStepFromTargets(board){
    if (!board) return null;
    const rb = board.getBoundingClientRect();
    if (!rb.width || !rb.height) return null;
    const pts = [...board.querySelectorAll('.lr-target')]
      .map(t => {
        const l = parseFloat(t.style.left);
        const tp = parseFloat(t.style.top);
        if (!Number.isFinite(l) || !Number.isFinite(tp)) return null;
        return { x: (l/100)*rb.width, y: (tp/100)*rb.height };
      })
      .filter(Boolean);

    if (pts.length < 10) return null;

    const rows = new Map();
    for (const p of pts){
      const key = Math.round(p.y/3)*3;
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(p);
    }

    const dx = [];
    for (const arr of rows.values()){
      if (arr.length < 3) continue;
      arr.sort((a,b)=>a.x-b.x);
      for (let i=1;i<arr.length;i++){
        const d = arr[i].x - arr[i-1].x;
        if (d > 6 && d < 250) dx.push(d);
      }
    }

    if (dx.length < 3) return null;
    return median(dx);
  }

  function applyTileVars(modal, board, factor=0.67){
    if (!modal || !board) return false;
    const step = calcStepFromTargets(board);
    if (step) {
      const tile = step * factor;
      const font = tile * 0.62;
      const hit = Math.max(18, Math.min(44, tile * 0.65));
      const dot = Math.max(2, Math.min(7, tile * 0.16));
      const ring = Math.max(1, Math.min(2, tile * 0.04));

      modal.style.setProperty('--lr-tile-size', `${tile}px`);
      modal.style.setProperty('--lr-tile', `${tile}px`);
      modal.style.setProperty('--lr-tile-font', `${font}px`);
      modal.style.setProperty('--lr-target-hit', `${hit}px`);
      modal.style.setProperty('--lr-target-dot', `${dot}px`);
      modal.style.setProperty('--lr-target-ring', `${ring}px`);
      positionBoardControls();
      return true;
    }

    const root = modal.classList.contains("is-open") ? modal : document.documentElement;
    const w = board.clientWidth;
    if (!w) return false;
    const styles = getComputedStyle(root);
    const mul = parseFloat(styles.getPropertyValue("--lr-tile-mul")) || 0.71;
    const fontMul = parseFloat(styles.getPropertyValue("--lr-font-mul")) || 0.5;
    const tile = w * TILE_K * mul;
    const font = Math.max(10, tile * fontMul);
    const hit = Math.max(18, Math.min(44, tile * 0.65));
    const dot = Math.max(2, Math.min(7, tile * 0.16));
    const ring = Math.max(1, Math.min(2, tile * 0.04));
    const target = modal || root;
    target.style.setProperty("--lr-tile", `${tile}px`);
    target.style.setProperty("--lr-tile-size", `${tile}px`);
    target.style.setProperty("--lr-tile-font", `${font}px`);
    target.style.setProperty("--lr-target-hit", `${hit}px`);
    target.style.setProperty("--lr-target-dot", `${dot}px`);
    target.style.setProperty("--lr-target-ring", `${ring}px`);
    positionBoardControls();
    return false;
  }

  function setupTileSizing(modal, board){
    if (!modal || !board) return () => {};
    let raf = 0;
    const recalcNow = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => applyTileVars(modal, board, 0.67));
    };
    const recalc = debounce(recalcNow, 80);

    recalcNow();

    let ro = null;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(() => recalc());
      ro.observe(board);
      window.__lrTileRO = ro;
    }

    const onResize = () => recalc();
    window.addEventListener('resize', onResize, { passive: true });

    return () => {
      cancelAnimationFrame(raf);
      if (ro) {
        ro.disconnect();
        if (window.__lrTileRO === ro) window.__lrTileRO = null;
      }
      window.removeEventListener('resize', onResize);
    };
  }

  function ensurePropInput(form, label) {
    const name = `properties[${label}]`;
    let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    return input;
  }

  function newDesignId() {
    return `LR-${Date.now()}-${Math.random().toString(36).slice(2,8).toUpperCase()}`;
  }

  function clampRot(rot) {
    if (rot === 0) return (Math.random() < 0.5 ? -5 : 5);
    if (ROT_STEPS.includes(rot)) return rot;
    let best = ROT_STEPS[0], bestD = Infinity;
    for (const s of ROT_STEPS) {
      const d = Math.abs(rot - s);
      if (d < bestD) { bestD = d; best = s; }
    }
    return best;
  }

  function randomRot() { return ROT_STEPS[Math.floor(Math.random() * ROT_STEPS.length)]; }

  function dist2(ax, ay, bx, by) {
    const dx = ax - bx, dy = ay - by;
    return dx*dx + dy*dy;
  }

  function inRect(x, y, rect) {
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function clearTargetHighlights(board) {
    $$(".lr-target", board).forEach(t => t.classList.remove("lr-target--ok", "lr-target--bad", "lr-target--blocker"));
    $$(".lr-tile", board).forEach(t => t.classList.remove("lr-tile--blocker"));
  }

  function positionBoardControls() {
    const boardEl = document.querySelector("#lr-board");
    const trashEl = document.querySelector("#lr-trash");
    const rotEl = document.querySelector("#lr-rotate");
    const resetEl = document.querySelector("#lr-reset");
    const resetConfirmEl = document.querySelector("#lr-resetConfirm");
    const modalEl = document.getElementById("lr-modal");
    const wrap = boardEl?.parentElement;
    if (!boardEl || !trashEl || !rotEl || !wrap || !modalEl) return;
    const br = boardEl.getBoundingClientRect();
    const wr = wrap.getBoundingClientRect();
    if (!br.width || !br.height) return;
    const pad = 8;
    const FAB_SCALE = 1.15;
    let fab = Math.min(60, Math.max(36, br.width * 0.08));
    fab = Math.round(fab * FAB_SCALE);
    const icon = Math.round(fab * 0.45);
    modalEl.style.setProperty("--lr-fab", `${fab}px`);
    modalEl.style.setProperty("--lr-fab-icon", `${icon}px`);
    modalEl.style.setProperty("--lr-fab-pad", `${pad}px`);

    const left = br.left - wr.left;
    const top = br.top - wr.top;

    trashEl.style.width = `${fab}px`;
    trashEl.style.height = `${fab}px`;
    trashEl.style.left = `${left + br.width - fab - pad}px`;
    trashEl.style.top = `${top + br.height - fab - pad}px`;
    const trashIconPx = Math.round(fab * 0.70);
    trashEl.style.fontSize = `${trashIconPx}px`;
    trashEl.style.lineHeight = "1";
    trashEl.style.display = "flex";
    trashEl.style.alignItems = "center";
    trashEl.style.justifyContent = "center";

    rotEl.style.height = `${fab}px`;
    rotEl.style.left = `${left + pad}px`;
    rotEl.style.top = `${top + br.height - fab - pad}px`;

    if (resetEl) {
      resetEl.classList.add("lr-trash");
      resetEl.style.right = "auto";
      resetEl.style.bottom = "auto";
      resetEl.setAttribute("aria-label", "Reset");
      resetEl.title = "Reset";

      const stack = window.matchMedia(LR_STACK_MQ).matches;
      const rxInside = left + pad;
      const rxOutside = left - fab - pad;
      let rx = stack ? Math.max(pad, rxOutside) : rxInside;
      rx = Math.min(rx, wr.width - fab - pad);
      let ry = top + br.height - fab - pad;
      ry = Math.min(ry, wr.height - fab - pad);
      ry = Math.max(pad, ry);

      resetEl.style.position = "absolute";
      resetEl.style.width = `${fab}px`;
      resetEl.style.height = `${fab}px`;
      resetEl.style.left = `${rx}px`;
      resetEl.style.top = `${ry}px`;

      if (resetConfirmEl && !resetConfirmEl.hasAttribute("hidden")) {
        const popPad = 6;
        const popHeight = resetConfirmEl.offsetHeight || resetConfirmEl.getBoundingClientRect().height;
        let popTop = ry + fab + popPad;
        if (popTop + popHeight > wr.height - pad) {
          popTop = ry - popHeight - popPad;
        }
        resetConfirmEl.style.position = "absolute";
        resetConfirmEl.style.left = `${rx}px`;
        resetConfirmEl.style.top = `${popTop}px`;
      }
    }
  }

  function normalizeCh(ch) {
    if (ch === "\\u0133") return LR_IJ;
    if (ch === "\\u0132") return LR_IJ_UP;
    if (ch === "\u0133") return LR_IJ;
    if (ch === "\u0132") return LR_IJ_UP;
    return ch;
  }

  function glyphLabel(ch) {
    ch = normalizeCh(ch);
    if (ch === LR_IJ) return "ij";
    if (ch === LR_IJ_UP) return "IJ";
    return ch;
  }
  function buildKeyboard() {
    const digits = ["1","2","3","4","5","6","7","8","9","0"];
    const specials = [null, ".", ",", "?", "!", "-", "&"];

    const qwertyLower = [
      ["q","w","e","r","t","y","u","i","o"],
      ["a","s","d","f","g","h","j","k","l"],
      ["z","x","c","v","b","n","m","p", LR_IJ],
    ];

    const lower = qwertyLower;
    const upper = lower.map(row =>
      row.map(ch => (ch === LR_IJ ? LR_IJ_UP : ch.toUpperCase()))
    );

    return [
      digits,
      [...lower[0], specials[1]],
      [...lower[1], specials[2]],
      [...lower[2], specials[3]],
      [...upper[0], specials[4]],
      [...upper[1], specials[5]],
      [...upper[2], specials[6]],
    ];
  }
  // ======= Image sampling helpers (voor auto-grid) =======
  function getDrawRect(boardRect, imgW, imgH) {
    // image is square in jouw render, maar houden het generiek
    const boardAR = boardRect.width / boardRect.height;
    const imgAR = imgW / imgH;
    let drawW, drawH;
    if (imgAR > boardAR) {
      drawW = boardRect.width;
      drawH = boardRect.width / imgAR;
    } else {
      drawH = boardRect.height;
      drawW = boardRect.height * imgAR;
    }
    const offX = (boardRect.width - drawW) / 2;
    const offY = (boardRect.height - drawH) / 2;
    return { drawW, drawH, offX, offY };
  }

  function boardPointToImagePx(boardRect, drawRect, imgW, imgH, clientX, clientY) {
    const x = clientX - boardRect.left;
    const y = clientY - boardRect.top;
    const rx = (x - drawRect.offX) / drawRect.drawW;
    const ry = (y - drawRect.offY) / drawRect.drawH;
    if (rx < 0 || ry < 0 || rx > 1 || ry > 1) return null;
    return { px: rx * imgW, py: ry * imgH, rx, ry };
  }

  function imagePxToBoardPct(boardRect, drawRect, imgW, imgH, px, py) {
    const rx = px / imgW;
    const ry = py / imgH;
    const x = drawRect.offX + rx * drawRect.drawW;
    const y = drawRect.offY + ry * drawRect.drawH;
    return { xPct: (x / boardRect.width) * 100, yPct: (y / boardRect.height) * 100 };
  }

  function isOnPinkHeart(r,g,b,a) {
    if (a < 10) return false;
    if ((r+g+b) < 30) return false; // bijna zwart
    // filter grijs/wit (voet) weg: daar zijn RGB bijna gelijk
    const d1 = Math.abs(r - g);
    const d2 = Math.abs(b - g);
    if (d1 < 12 && d2 < 12) return false;
    // heart is roze-ish: rood meestal hoger dan groen
    if (r < 80) return false;
    if (r - g < 8) return false;
    return true;
  }

  function main() {
    const cfg = parseConfig();
    cfg.minTiles = Number(cfg.minTiles) || 1;

    const btnOpen = $("#lr-open");
    const modal = $("#lr-modal");
    const board = $("#lr-board");
    const boardWrap = board?.parentElement || $("#lr-board")?.parentElement;
    const kbWrap = modal?.querySelector(".lr-kbWrap") || $("#lr-modal .lr-kbWrap");
    const keyboard = $("#lr-keyboard");
    const btnSave = $("#lr-save");
    const btnShift = $("#lr-shift");
    if (btnShift) btnShift.style.display = "none";
    const btnReset = $("#lr-reset");
    const status = $("#lr-status");
    const trash = $("#lr-trash");
    const rotateBox = $("#lr-rotate");
    const rotL = $("#lr-rotL");
    const rotR = $("#lr-rotR");
    if (rotL) rotL.textContent = "↺";
    if (rotR) rotR.textContent = "↻";
    const selFont = $("#lr-font");
    const selColor = $("#lr-color");
    let resetOriginalParent = null;
    let resetOriginalNext = null;
    let controlsOriginalParent = null;
    let controlsOriginalNext = null;
    let resetBak = null;
    let resetConfirmEl = null;
    let resetConfirmCleanup = null;
    const RESET_SVG =
      "<svg viewBox=\"0 0 232 232\" aria-hidden=\"true\" focusable=\"false\"><path fill=\"currentColor\" d=\"M42.2,128h-18.99c-4.87,0-7.32,5.89-3.87,9.34l29.69,29.69c2.14,2.14,5.6,2.14,7.74,0l29.69-29.69c3.45-3.45,1.01-9.34-3.87-9.34h-18.99c0-35.5,28.9-64.4,64.4-64.4,8.32,0,16.35,1.6,23.67,4.54,4.01,1.61,8.59.71,11.64-2.35h0c5.43-5.43,3.59-14.68-3.54-17.55-9.82-3.95-20.55-6.14-31.77-6.14-47.4.1-85.8,38.5-85.8,85.9h0ZM192.4,128c0,35.5-28.9,64.4-64.4,64.4-8.32,0-16.35-1.6-23.67-4.54-4.01-1.61-8.59-.71-11.64,2.35h0c-5.43,5.44-3.59,14.68,3.53,17.55,9.8,3.95,20.5,6.14,31.78,6.14,47.4,0,85.8-38.4,85.8-85.8h18.99c4.87,0,7.32-5.89,3.87-9.34l-29.69-29.69c-2.14-2.14-5.6-2.14-7.73,0l-29.66,29.59c-3.45,3.45-1.01,9.35,3.86,9.35h18.97Z\"/></svg>";
    if (btnSave) btnSave.type = "button";
    if (trash) {
      trash.setAttribute("role", "button");
      trash.tabIndex = 0;
      trash.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          trash.click();
        }
      });
    }

    const debugWrap = $("#lr-debug");
    const debugHelp = $("#lr-debugHelp");
    const btnAutoStart = $("#lr-autoStart");
    const btnExportTargets = $("#lr-exportTargets");
    const btnClearTargets = $("#lr-clearTargets");
    const exportBox = $("#lr-exportBox");
    let neighborsMap = new Map();
    let neighborHash = null;
    let cleanupTileSizing = null;
    let cleanupKeyboardSizing = null;
    let cleanupControlsDocking = null;
    let cleanupFitBoard = null;
    let cleanupVV = null;
    let cleanupDD = null;
    let cleanupWwkSync = null;
    let cleanupWwkHide = null;
    let cleanupVVBottom = null;

    if (!btnOpen || !modal || !board || !keyboard) return;
    if (!cleanupVVBottom) cleanupVVBottom = setupVVBottomVar();
    if (!cleanupWwkHide) cleanupWwkHide = setupWwkDesktopHide();

    btnOpen.type = "button";
    btnOpen.removeAttribute("name");
    btnOpen.removeAttribute("value");

    function ensureFlowerEl() {
      let el = document.getElementById("lr-flower");
      if (!el) {
        el = document.createElement("div");
        el.id = "lr-flower";
        el.className = "lr-piece lr-flower";
        el.setAttribute("role", "button");
        el.setAttribute("aria-label", "Bloem");
        board.appendChild(el);
      }
      return el;
    }

    const flowerEl = ensureFlowerEl();

    function isDropOnKeyboardArea(clientX, clientY) {
      const kb = $("#lr-modal #lr-keyboard");
      const wrap = $("#lr-modal .lr-kbWrap");
      const el = kb || wrap;
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return clientX >= r.left && clientX <= r.right && clientY >= r.top && clientY <= r.bottom;
    }

    // product form
    const form =
      document.querySelector("form[action='/cart/add']") ||
      document.querySelector("form[action*='/cart/add']");

    if (!form) {
      console.warn("Geen cart/add form gevonden");
      return;
    }

    // hidden props
    const inputText = ensurePropInput(form, "Love Rock tekst");
    const inputFont = ensurePropInput(form, "Love Rock font");
    const inputColor = ensurePropInput(form, "Love Rock kleur");
    const inputDesignId = ensurePropInput(form, "Love Rock design_id");
    const inputPretty = ensurePropInput(form, "Gekozen letters");

    // background
    board.style.backgroundImage = `url(${cfg.bgUrl})`;

    // state
    let layoutMode = "qwerty";

    let selectedPos = null;
    let selectedFlower = false;
    let dragging = null; // {type:'key'|'tile'|'flower', ...}
    let ghost = null;
    let armedKeyCh = null;
    let dragType = null;
    let dragFromPosId = null;

    // placements: posId -> {ch, rot}
    let placements = new Map();
    let flower = { anchorPosId: null };

    // meta
    let currentDesignId = null;
    const uiState = { font: null };
    let currentFont = cfg.fonts?.[0]?.id || "lilitaone";
    let currentColor = cfg.colors?.[0]?.value || "#111111";
    const setCurrentColorVar = () => {
      document.documentElement.style.setProperty("--lr-current-color", currentColor);
    };
    setCurrentColorVar();
    const fontKey = `lr:font:${cfg.productHandle}`;
    const savedFont = safeGetItem(fontKey);
    if (savedFont) currentFont = savedFont;

    // targets
    const targetsKey = `lr:targets:${cfg.productHandle}`;
    let targets = Array.isArray(cfg.targets) ? cfg.targets.slice() : [];
    if (!targets.length) {
      try {
        const saved = safeGetItem(targetsKey);
        if (saved) targets = JSON.parse(saved);
      } catch {}
    }
    if (!flower.anchorPosId && targets.find(t => t.id === "r03c07")) {
      flower.anchorPosId = "r03c07";
    }
    const getTargetByPosId = (id) => targets.find(t => t.id === id) || null;
    const getTargetCenterNorm = (id) => {
      const t = getTargetByPosId(id);
      if (!t) return null;
      return { nx: t.xPct / 100, ny: t.yPct / 100 };
    };

    // ===== debug flags =====
    const debug = qs("lr_debug") === "1";
    if (debug) debugWrap.hidden = false;

    function setStatus(msg) { if (status) status.textContent = msg || ""; }
    function rootEl() { return document.querySelector(".lr-modal.is-open") || document.documentElement; }
    function tileHalfPx() {
      const root = rootEl();
      const styles = root ? getComputedStyle(root) : null;
      const val = styles
        ? (styles.getPropertyValue("--lr-tile-size") || styles.getPropertyValue("--lr-tile"))
        : "";
      const size = parseFloat(val);
      return (Number.isFinite(size) ? size : 42) / 2;
    }
    function lrApplyFont(fontId, cfgObj, state) {
  const f = (cfgObj.fonts || []).find(x => x.id === fontId);
  if (!f) return;

  const fam = `"${f.cssFamily}"`;

  // 1) modal: keys + tiles
  modal.style.setProperty("--lr-font-family", fam);

  // 2) root + body: ghost tile (staat buiten modal)
  document.documentElement.style.setProperty("--lr-font-family", fam);
  document.body.style.setProperty("--lr-font-family", fam);

  // optioneel: preload zodat je geen “flash” krijgt
  try { document.fonts.load(`16px ${fam}`); } catch {}

  state.font = fontId;
  safeSetItem(fontKey, fontId);
}


    function refreshTileVars() {
      applyTileVars(modal, board, 0.67);
    }

    function setupTileObserver() {
      if (window.__lrTileRO) { window.__lrTileRO.disconnect(); window.__lrTileRO = null; }
      if (cleanupTileSizing) { cleanupTileSizing(); cleanupTileSizing = null; }
      if (!board || !modal) return;
      refreshTileVars();
      requestAnimationFrame(refreshTileVars);
      cleanupTileSizing = setupTileSizing(modal, board);
    }

    window.lrSet = (opts={}) => {
      const root = rootEl();
      if (!root) return;
      const { mul, fontMul, border, radius } = opts;
      if (mul != null) root.style.setProperty("--lr-tile-mul", mul);
      if (fontMul != null) root.style.setProperty("--lr-font-mul", fontMul);
      if (border != null) root.style.setProperty("--lr-border", typeof border === "number" ? `${border}px` : border);
      if (radius != null) root.style.setProperty("--lr-radius", typeof radius === "number" ? `${radius}px` : radius);
      refreshTileVars();
    };

    function ensureFooterRight() {
      const footer = modal?.querySelector(".lr-footer");
      if (!footer) return null;
      let spacer = footer.querySelector(".lr-footerSpacer");
      if (!spacer) {
        spacer = document.createElement("div");
        spacer.className = "lr-footerSpacer";
        footer.insertBefore(spacer, footer.firstChild || null);
      }
      let right = footer.querySelector(".lr-footerRight");
      if (!right) {
        right = document.createElement("div");
        right.className = "lr-footerRight";
        footer.appendChild(right);
      }
      return right;
    }

    function ensureFooterLeft() {
      const footer = modal?.querySelector(".lr-footer");
      if (!footer) return null;
      const right = ensureFooterRight();
      if (!right) return null;
      let left = footer.querySelector(".lr-footerLeft");
      if (!left) {
        left = document.createElement("div");
        left.className = "lr-footerLeft";
        footer.insertBefore(left, right);
      } else if (left.nextSibling !== right) {
        footer.insertBefore(left, right);
      }
      return left;
    }

    function moveResetIntoFooter() {
      if (!btnSave) return;
      const right = ensureFooterRight();
      if (!right) return;
      right.appendChild(btnSave);
    }

    function moveControlsIntoFooter() {
      const kbControls = modal?.querySelector(".lr-kbControls");
      if (!kbControls) return;
      const left = ensureFooterLeft();
      if (!left) return;
      if (!controlsOriginalParent) {
        controlsOriginalParent = kbControls.parentElement;
        controlsOriginalNext = kbControls.nextSibling;
      }
      left.appendChild(kbControls);
    }

    function restoreControlsHome() {
      const kbControls = modal?.querySelector(".lr-kbControls");
      if (!kbControls || !controlsOriginalParent) return;
      if (controlsOriginalNext && controlsOriginalNext.parentNode === controlsOriginalParent) {
        controlsOriginalParent.insertBefore(kbControls, controlsOriginalNext);
      } else {
        controlsOriginalParent.appendChild(kbControls);
      }
    }

    function syncControlsDock() {
      if (!modal.classList.contains("is-open")) return;
      const stack = window.matchMedia(LR_STACK_MQ).matches;
      if (stack) moveControlsIntoFooter();
      else restoreControlsHome();
      requestAnimationFrame(() => { syncKeySizeVar(); });
    }

    function startControlsDocking() {
      const mql = window.matchMedia(LR_STACK_MQ);
      const handler = () => setTimeout(syncControlsDock, 0);
      if (mql.addEventListener) mql.addEventListener("change", handler);
      else if (mql.addListener) mql.addListener(handler);
      window.addEventListener("resize", handler, { passive: true });
      window.addEventListener("orientationchange", handler, { passive: true });
      window.visualViewport?.addEventListener("resize", handler, { passive: true });
      syncControlsDock();
      return () => {
        if (mql.removeEventListener) mql.removeEventListener("change", handler);
        else if (mql.removeListener) mql.removeListener(handler);
        window.removeEventListener("resize", handler);
        window.removeEventListener("orientationchange", handler);
        window.visualViewport?.removeEventListener("resize", handler);
      };
    }

    function restoreResetHome() {
      if (!btnReset || !resetOriginalParent) return;
      if (resetOriginalNext && resetOriginalNext.parentNode === resetOriginalParent) {
        resetOriginalParent.insertBefore(btnReset, resetOriginalNext);
      } else {
        resetOriginalParent.appendChild(btnReset);
      }
    }

    function ensureResetIcon() {
      if (!btnReset) return;
      if (!btnReset.dataset.lrIcon) {
        btnReset.innerHTML = RESET_SVG;
        btnReset.dataset.lrIcon = "reset";
      }
    }

    function ensureResetConfirmUI() {
      if (resetConfirmEl) return resetConfirmEl;
      if (!boardWrap) return null;
      const wrap = document.createElement("div");
      wrap.id = "lr-resetConfirm";
      wrap.hidden = true;
      wrap.innerHTML =
        "<div class=\"lr-confirmText\">Opnieuw beginnen?</div>" +
        "<div class=\"lr-confirmRow\">" +
          "<button type=\"button\" class=\"lr-confirmBtn lr-confirmBtn--no\" aria-label=\"Annuleren\" title=\"Annuleren\">" +
            "<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M6 6L18 18M18 6L6 18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.6\" stroke-linecap=\"round\"/></svg>" +
          "</button>" +
          "<button type=\"button\" class=\"lr-confirmBtn lr-confirmBtn--yes\" aria-label=\"Bevestigen\" title=\"Bevestigen\">" +
            "<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M5 13l4 4L19 7\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>" +
          "</button>" +
        "</div>";
      boardWrap.appendChild(wrap);
      resetConfirmEl = wrap;

      const btnCancel = wrap.querySelector(".lr-confirmBtn--no");
      const btnOk = wrap.querySelector(".lr-confirmBtn--yes");
      if (btnCancel) btnCancel.addEventListener("click", hideResetConfirm);
      if (btnOk) btnOk.addEventListener("click", () => {
        hideResetConfirm();
        runReset();
      });
      return resetConfirmEl;
    }

    function showResetConfirm() {
      const pop = ensureResetConfirmUI();
      if (!pop) return;
      pop.hidden = false;
      positionBoardControls();
      if (resetConfirmCleanup) return;
      const handler = (e) => {
        if (!resetConfirmEl || resetConfirmEl.hidden) return;
        if (resetConfirmEl.contains(e.target)) return;
        if (btnReset && btnReset.contains(e.target)) return;
        hideResetConfirm();
      };
      document.addEventListener("pointerdown", handler, true);
      resetConfirmCleanup = () => {
        document.removeEventListener("pointerdown", handler, true);
        resetConfirmCleanup = null;
      };
    }

    function hideResetConfirm() {
      if (!resetConfirmEl || resetConfirmEl.hidden) return;
      resetConfirmEl.hidden = true;
      if (resetConfirmCleanup) resetConfirmCleanup();
    }

    function dockResetFab() {
      if (!btnReset || !boardWrap) return;
      if (!resetBak) {
        resetBak = {
          parent: btnReset.parentElement,
          next: btnReset.nextSibling,
          className: btnReset.className,
          style: btnReset.getAttribute("style") || "",
          text: btnReset.textContent
        };
      }
      ensureResetIcon();
      btnReset.classList.add("lr-trash");
      btnReset.setAttribute("aria-label", "Reset");
      btnReset.title = "Reset";

      if (btnReset.parentElement !== boardWrap) boardWrap.appendChild(btnReset);
      positionBoardControls();
    }

    function undockResetFab() {
      if (!btnReset || !resetBak) return;
      btnReset.className = resetBak.className;
      btnReset.textContent = resetBak.text;
      btnReset.setAttribute("style", resetBak.style);
      delete btnReset.dataset.lrIcon;

      if (resetBak.parent) {
        if (resetBak.next && resetBak.next.parentNode === resetBak.parent) {
          resetBak.parent.insertBefore(btnReset, resetBak.next);
        } else {
          resetBak.parent.appendChild(btnReset);
        }
      }
    }

    function fitBoardInStack(modalEl) {
      if (!modalEl) return;
      const sheet = modalEl.querySelector(".lr-sheet");
      const body = modalEl.querySelector(".lr-body");
      const topbar = modalEl.querySelector(".lr-topbar");
      const footer = modalEl.querySelector(".lr-footer");
      const boardWrap = modalEl.querySelector(".lr-boardWrap");
      const boardEl = modalEl.querySelector("#lr-board");
      const kbWrap = modalEl.querySelector(".lr-kbWrap");
      if (!sheet || !body || !boardWrap || !boardEl || !kbWrap) return;

      if (!window.matchMedia(LR_STACK_MQ).matches) {
        boardWrap.style.width = "";
        boardWrap.style.maxWidth = "";
        boardWrap.style.marginInline = "";
        return;
      }

      const sr = sheet.getBoundingClientRect();
      const tr = topbar?.getBoundingClientRect();
      const fr = footer?.getBoundingClientRect();
      const bodyCS = getComputedStyle(body);
      const padY = num(bodyCS.paddingTop) + num(bodyCS.paddingBottom);
      const gap = num(bodyCS.rowGap) || num(bodyCS.gap) || 8;
      const availBodyH = Math.max(120, sr.height - (tr?.height || 0) - (fr?.height || 0));
      const kbNeed = kbWrap.scrollHeight || kbWrap.getBoundingClientRect().height;
      const aspect = parseAspect(boardEl);
      const availBoardH = Math.max(80, availBodyH - padY - kbNeed - gap);

      const br = body.getBoundingClientRect();
      const padX = num(bodyCS.paddingLeft) + num(bodyCS.paddingRight);
      const containerW = Math.max(140, br.width - padX);
      const targetW = Math.min(containerW, Math.floor(availBoardH * aspect));
      const clamped = Math.max(140, targetW);

      // Explicit width prevents 1px collapse when grid is constrained.
      boardWrap.style.width = `${clamped}px`;
      boardWrap.style.maxWidth = "100%";
      boardWrap.style.marginInline = "auto";

      requestAnimationFrame(() => { syncKeySizeVar(); });
    }

    function startFitBoard(modalEl) {
      const mql = window.matchMedia(LR_STACK_MQ);
      let t = 0;
      const schedule = () => {
        clearTimeout(t);
        t = setTimeout(() => requestAnimationFrame(() => fitBoardInStack(modalEl)), 0);
      };
      const handler = () => schedule();

      mql.addEventListener("change", handler);
      window.addEventListener("resize", handler, { passive: true });
      window.visualViewport?.addEventListener("resize", handler, { passive: true });

      schedule();

      return () => {
        mql.removeEventListener("change", handler);
        window.removeEventListener("resize", handler);
        window.visualViewport?.removeEventListener("resize", handler);
        clearTimeout(t);

        const boardWrap = modalEl?.querySelector(".lr-boardWrap");
        if (boardWrap) {
          boardWrap.style.width = "";
          boardWrap.style.maxWidth = "";
          boardWrap.style.marginInline = "";
        }
      };
    }

    function setupWwkVisibilitySync(modalEl) {
      if (!modalEl || !isLoveRockPage()) return () => {};
      const apply = () => {
        document.body.classList.toggle("lr-editor-open", modalEl.classList.contains("is-open"));
      };
      apply();
      const obs = new MutationObserver(apply);
      obs.observe(modalEl, { attributes: true, attributeFilter: ["class"] });
      return () => obs.disconnect();
    }

    function setupWwkDesktopHide() {
      if (!isLoveRockPage()) return () => {};
      const mq = window.matchMedia("(min-width: 990px)");
      const apply = () => {
        if (!mq.matches) return;
        document.querySelectorAll("#wwkSidebar, .wwk-sidebar, #wwkSidebarPopup, .wwk-sidebar-popup")
          .forEach((el) => {
            el.style.setProperty("display", "none", "important");
            el.style.setProperty("visibility", "hidden", "important");
            el.style.setProperty("pointer-events", "none", "important");
          });
      };
      apply();
      const obs = new MutationObserver(apply);
      obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"] });
      const onMq = () => apply();
      if (mq.addEventListener) mq.addEventListener("change", onMq);
      else if (mq.addListener) mq.addListener(onMq);
      window.addEventListener("resize", onMq, { passive: true });
      return () => {
        obs.disconnect();
        if (mq.removeEventListener) mq.removeEventListener("change", onMq);
        else if (mq.removeListener) mq.removeListener(onMq);
        window.removeEventListener("resize", onMq);
      };
    }

    function openModal() {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("lr-editor-open");
      if (!cleanupWwkSync) cleanupWwkSync = setupWwkVisibilitySync(modal);
      if (cleanupVV) { cleanupVV(); cleanupVV = null; }
      cleanupVV = lrSyncVisualViewport(modal);
      dockResetFab();
      moveResetIntoFooter();
      if (cleanupControlsDocking) { cleanupControlsDocking(); cleanupControlsDocking = null; }
      cleanupControlsDocking = startControlsDocking();
      lockScroll(true);
      restoreLastDraft();
      renderAll();
      if (cleanupDD) { cleanupDD(); cleanupDD = null; }
      cleanupDD = initDDManager();
      setupTileObserver();
      if (cleanupFitBoard) { cleanupFitBoard(); cleanupFitBoard = null; }
      cleanupFitBoard = startFitBoard(modal);
      if (cleanupKeyboardSizing) { cleanupKeyboardSizing(); cleanupKeyboardSizing = null; }
      cleanupKeyboardSizing = setupKeyboardSizing(modal, boardWrap, kbWrap, keyboard);
      requestAnimationFrame(() => { cleanupKeyboardSizing?.(); cleanupKeyboardSizing = setupKeyboardSizing(modal, boardWrap, kbWrap, keyboard); });
      startGhostObserver();
      buildNeighbors(true);
      syncKeySizeVar();
      setTimeout(() => syncKeySizeVar(), 0);
      setTimeout(() => syncKeySizeVar(), 120);
      setTimeout(() => syncKeySizeVar(), 350);
      if (debug) setStatus("DEBUG aan. Gebruik Auto-grid wizard of export.");
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("lr-editor-open");
      lockScroll(false);
      setArmedKey(null, { toggle: false });
      hideResetConfirm();
      stopGhostObserver();
      if (cleanupDD) { cleanupDD(); cleanupDD = null; }
      if (cleanupVV) { cleanupVV(); cleanupVV = null; }
      if (cleanupKeyboardSizing) { cleanupKeyboardSizing(); cleanupKeyboardSizing = null; }
      if (cleanupTileSizing) { cleanupTileSizing(); cleanupTileSizing = null; }
      if (cleanupControlsDocking) { cleanupControlsDocking(); cleanupControlsDocking = null; }
      if (cleanupFitBoard) { cleanupFitBoard(); cleanupFitBoard = null; }
      if (window.__lrTileRO) { window.__lrTileRO.disconnect(); window.__lrTileRO = null; }
      undockResetFab();
      restoreControlsHome();
      clearDrag();
    }

  function clearDrag() {
    board.classList.remove("is-dragging");
    $$(".lr-target", board).forEach(t => t.classList.remove("hover"));
    if (flowerEl) flowerEl.classList.remove("is-dragging");
    if (ghost) ghost.remove();
    ghost = null;
    dragging = null;
    dragType = null;
    dragFromPosId = null;
    clearTargetHighlights(board);
    updateBaseAvailability();
  }

    function updateKeyboardArmedUI() {
      const ch = armedKeyCh;
      $$(".lr-key", keyboard).forEach(k => {
        const on = !!ch && k.dataset.ch === ch;
        k.classList.toggle("is-armed", on);
      });
      if (ch) board.classList.add("is-armed");
      else board.classList.remove("is-armed");
    }

    function setArmedKey(chOrNull, { toggle=true } = {}) {
      let next = chOrNull || null;
      if (toggle && next && next === armedKeyCh) next = null;
      armedKeyCh = next;
      selectedPos = null;
      setFlowerSelected(false, { silent: true });
      updateKeyboardArmedUI();
      renderTiles();
      positionBoardControls();
    }

    function clearAllSelection() {
      selectedPos = null;
      setFlowerSelected(false, { silent: true });
      armedKeyCh = null;
      updateKeyboardArmedUI();
      renderTiles();
      positionBoardControls();
    }

    function ensurePrebadStyle() {
      if (document.getElementById("lr-prebad-style")) return;
      const st = document.createElement("style");
      st.id = "lr-prebad-style";
      st.textContent = `#lr-modal .lr-target--prebad{outline:none !important;background:transparent !important;box-shadow:none !important;}#lr-modal .lr-target--prebad::after{background:rgba(220,0,0,.95);box-shadow:0 0 0 var(--lr-target-ring) rgba(255,255,255,.65),0 0 8px rgba(220,0,0,.35);}`;
      document.head.appendChild(st);
    }

    function setupVVBottomVar() {
      if (window.__lrVVBottomSetup) return window.__lrVVBottomCleanup || (() => {});
      window.__lrVVBottomSetup = true;
      const root = document.documentElement;
      const vv = window.visualViewport;
      let raf = 0;

      const apply = () => {
        const bot = vv ? Math.max(0, window.innerHeight - (vv.height + vv.offsetTop)) : 0;
        root.style.setProperty("--vv-bottom", `${Math.round(bot)}px`);
      };

      const schedule = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(apply);
      };

      schedule();
      window.addEventListener("resize", schedule, { passive: true });
      window.addEventListener("orientationchange", schedule, { passive: true });
      window.addEventListener("pageshow", schedule, { passive: true });
      if (vv) {
        vv.addEventListener("resize", schedule, { passive: true });
        vv.addEventListener("scroll", schedule, { passive: true });
      }

      const cleanup = () => {
        cancelAnimationFrame(raf);
        window.removeEventListener("resize", schedule);
        window.removeEventListener("orientationchange", schedule);
        window.removeEventListener("pageshow", schedule);
        if (vv) {
          vv.removeEventListener("resize", schedule);
          vv.removeEventListener("scroll", schedule);
        }
        root.style.removeProperty("--vv-bottom");
        window.__lrVVBottomSetup = false;
        window.__lrVVBottomCleanup = null;
      };

      window.__lrVVBottomCleanup = cleanup;
      return cleanup;
    }

    function lrSyncVisualViewport(modalEl) {
      if (!modalEl) return () => {};
      const vv = window.visualViewport;

      const apply = () => {
        const h = vv ? vv.height : window.innerHeight;
        const top = vv ? vv.offsetTop : 0;
        const bot = vv ? Math.max(0, window.innerHeight - (vv.height + vv.offsetTop)) : 0;
        modalEl.style.setProperty("--lr-vvh", `${Math.round(h)}px`);
        modalEl.style.setProperty("--lr-vvtop", `${Math.round(top)}px`);
        modalEl.style.setProperty("--lr-vvbot", `${Math.round(bot)}px`);
      };

      apply();
      requestAnimationFrame(apply);
      setTimeout(apply, 50);
      setTimeout(apply, 150);
      setTimeout(apply, 300);
      setTimeout(apply, 600);

      const onWinResize = () => apply();
      const onOrientation = () => {
        apply();
        requestAnimationFrame(apply);
        setTimeout(apply, 50);
        setTimeout(apply, 150);
        setTimeout(apply, 300);
        setTimeout(() => syncKeySizeVar(), 0);
        setTimeout(() => syncKeySizeVar(), 120);
      };
      window.addEventListener("resize", onWinResize, { passive: true });
      window.addEventListener("orientationchange", onOrientation, { passive: true });
      window.addEventListener("pageshow", onWinResize, { passive: true });

      let onVVResize = null;
      let onVVScroll = null;
      if (vv) {
        onVVResize = () => apply();
        onVVScroll = () => apply();
        vv.addEventListener("resize", onVVResize, { passive: true });
        vv.addEventListener("scroll", onVVScroll, { passive: true });
      }

      return () => {
        window.removeEventListener("resize", onWinResize);
        window.removeEventListener("orientationchange", onOrientation);
        window.removeEventListener("pageshow", onWinResize);
        if (vv && onVVResize) vv.removeEventListener("resize", onVVResize);
        if (vv && onVVScroll) vv.removeEventListener("scroll", onVVScroll);
      };
    }

    function setupKeyboardSizing(modalEl, boardWrapEl, kbWrapEl, keyboardEl) {
      if (!modalEl || !kbWrapEl || !keyboardEl) return () => {};
      let frame = 0;
      const apply = () => {
        const styles = getComputedStyle(modalEl);
        const tile = parseFloat(styles.getPropertyValue("--lr-tile-size")) || 42;

        const gapVar = parseFloat(styles.getPropertyValue("--lr-key-gap"));
        const baseGap = Number.isFinite(gapVar) ? gapVar : Math.max(4, Math.min(10, tile * 0.10));

        const wrapStyle = getComputedStyle(kbWrapEl);
        const padL = parseFloat(wrapStyle.paddingLeft) || 0;
        const padR = parseFloat(wrapStyle.paddingRight) || 0;

        const availRaw = (kbWrapEl.clientWidth || keyboardEl.clientWidth || 0) - padL - padR;
        const cols = 10;

        let keySize = tile;
        let keyGap = baseGap;

        if (availRaw > 0) {
          let gap = Math.max(2, Math.min(10, baseGap));
          let ks = Math.floor((availRaw - gap * (cols - 1)) / cols);

          if (ks < 26) {
            gap = 2;
            ks = Math.floor((availRaw - gap * (cols - 1)) / cols);
          }

          ks = Math.max(26, Math.min(tile, ks));
          keySize = ks;
          keyGap = gap;
        }

        modalEl.style.setProperty("--lr-key-size", `${keySize}px`);
        modalEl.style.setProperty("--lr-key-gap", `${keyGap}px`);
        modalEl.style.setProperty("--lr-key-font", `${keySize * 0.62}px`);
      };
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(apply);
      };
      schedule();
      const ro = new ResizeObserver(schedule);
      ro.observe(kbWrapEl);
      if (boardWrapEl) ro.observe(boardWrapEl);
      const onResize = () => schedule();
      window.addEventListener("resize", onResize, { passive: true });
      const vv = window.visualViewport;
      const onVV = () => schedule();
      if (vv) {
        vv.addEventListener("resize", onVV, { passive: true });
        vv.addEventListener("scroll", onVV, { passive: true });
      }
      return () => {
        cancelAnimationFrame(frame);
        ro.disconnect();
        window.removeEventListener("resize", onResize);
        if (vv) {
          vv.removeEventListener("resize", onVV);
          vv.removeEventListener("scroll", onVV);
        }
      };
    }

    function updateBaseAvailability() {
      if (!board) return;
      const targetsEls = board.querySelectorAll(".lr-target[data-pos-id]");
      if (!targetsEls.length) return;
      ensurePrebadStyle();

      const occ = new Set();
      board.querySelectorAll(".lr-tile[data-pos-id]").forEach(el => {
        const id = el.dataset.posId;
        if (id) occ.add(id);
      });

      const ignoreFlower = board.classList.contains("is-dragging") && dragType === "flower";
      if (!ignoreFlower) {
        const fo = getFlowerOccupied(flower.anchorPosId);
        if (fo) fo.forEach(id => occ.add(id));
      }

      if (board.classList.contains("is-dragging") && dragType === "tile" && dragFromPosId) {
        occ.delete(dragFromPosId);
      }

      const neighMap = neighborsMap || window.lrNeighbors;
      targetsEls.forEach(el => {
        const id = el.dataset.posId;
        if (!id) return;
        const neigh = neighMap?.get ? neighMap.get(id) : null;
        const blockedSelf = occ.has(id);
        let blockedDiag = false;
        if (neigh) {
          ["UL","UR","DL","DR"].some(k => {
            const nid = neigh[k];
            if (nid && occ.has(nid)) {
              blockedDiag = true;
              return true;
            }
            return false;
          });
        }
        const blocked = blockedSelf || blockedDiag;
        el.classList.toggle("lr-target--prebad", !!blocked);
      });
    }

    const selectsState = { init: false };
    let fontDD = null;
    let colorDD = null;

    function createDropUp(selectEl, { renderLabel, renderOption }={}) {
      const wrap = document.createElement("div");
      wrap.className = "lr-dd";
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "lr-ddBtn";
      const menu = document.createElement("div");
      menu.className = "lr-ddMenu";
      menu.hidden = true;
      wrap.appendChild(btn);
      wrap.appendChild(menu);
      selectEl.insertAdjacentElement("afterend", wrap);

      const setContent = (el, content) => {
        el.innerHTML = "";
        if (content == null) return;
        if (typeof content === "string") el.textContent = content;
        else el.appendChild(content);
      };

      const closeMenu = () => {
        menu.hidden = true;
        wrap.classList.remove("open");
        wrap.__lrDDState?.onClose?.();
      };
      const buildMenu = () => {
        menu.innerHTML = "";
        Array.from(selectEl.options).forEach((opt) => {
          const item = document.createElement("button");
          item.type = "button";
          item.className = "lr-ddItem";
          setContent(item, renderOption ? renderOption(opt) : opt.textContent);
          item.addEventListener("click", () => {
            selectEl.value = opt.value;
            selectEl.dispatchEvent(new Event("change", { bubbles: true }));
            closeMenu();
          });
          menu.appendChild(item);
        });
      };

      const updateLabel = () => {
        const opt = selectEl.options[selectEl.selectedIndex];
        setContent(btn, renderLabel ? renderLabel(opt) : (opt?.textContent || ""));
      };

      wrap.__lrDDState = { menu, btn, buildMenu, closeMenu };
      selectEl.addEventListener("change", updateLabel);

      updateLabel();
      return { update: updateLabel, close: closeMenu, wrap, btn, menu, buildMenu };
    }

    function initDDManager() {
      if (window.__lrDDManagerInstalled) return window.__lrDDManagerCleanup || (() => {});
      window.__lrDDManagerInstalled = true;

      const MQ = "(max-width: 900px) and (orientation: portrait), (max-width: 665px) and (orientation: landscape)";
      const isStack = () => matchMedia(MQ).matches;

      const DD = {};
      const state = { openKind: null };

      const grab = (kind) => {
        const field = document.querySelector(`.lr-field-${kind}`);
        const dd = field?.querySelector(".lr-dd");
        const btn = dd?.querySelector(".lr-ddBtn");
        const menu = dd?.querySelector(".lr-ddMenu");
        if (!field || !dd || !btn || !menu) return null;
        btn.dataset.kind = kind;
        menu.dataset.kind = kind;
        return {
          kind,
          field,
          dd,
          btn,
          menu,
          home: { parent: dd, nextSibling: menu.nextSibling || null }
        };
      };

      DD.color = grab("color");
      DD.font = grab("font");

      const setMenuFixed = (menu) => {
        menu.style.position = "fixed";
        menu.style.zIndex = "999999";
        menu.style.display = "block";
        menu.style.visibility = "visible";
        menu.style.opacity = "1";
        menu.style.left = "0px";
        menu.style.top = "0px";
        menu.style.right = "auto";
        menu.style.bottom = "auto";
        menu.style.width = "auto";
      };

      const restoreMenu = (kind) => {
        const d = DD[kind];
        if (!d) return;
        const { menu, home } = d;
        if (home.parent) {
          if (home.nextSibling && home.nextSibling.parentNode === home.parent) {
            home.parent.insertBefore(menu, home.nextSibling);
          } else {
            home.parent.appendChild(menu);
          }
        }
        menu.style.position = "";
        menu.style.zIndex = "";
        menu.style.display = "";
        menu.style.visibility = "";
        menu.style.opacity = "";
        menu.style.left = "";
        menu.style.top = "";
        menu.style.right = "";
        menu.style.bottom = "";
        menu.style.width = "";
        menu.style.minWidth = "";
        menu.style.maxHeight = "";
        menu.style.overflow = "";
      };

      const portalMenu = (kind) => {
        const d = DD[kind];
        if (!d) return;
        if (d.menu.parentElement !== document.body) {
          document.body.appendChild(d.menu);
        }
        setMenuFixed(d.menu);
      };

      const positionMenu = (kind) => {
        const d = DD[kind];
        if (!d || d.menu.hidden) return;
        const r = d.btn.getBoundingClientRect();
        const gap = 8;
        const margin = 8;
        const wantUp = isStack();
        d.dd.classList.toggle("is-stack", wantUp);
        d.dd.classList.toggle("dropup", wantUp);
        d.dd.classList.toggle("dropdown", !wantUp);

        const menuRect = d.menu.getBoundingClientRect();
        const mw = menuRect.width || d.menu.offsetWidth || r.width;
        const mh = menuRect.height || d.menu.offsetHeight || 0;
        const maxLeft = Math.max(margin, window.innerWidth - mw - margin);
        const left = Math.min(Math.max(r.left, margin), maxLeft);

        let top;
        if (wantUp) {
          top = r.top - mh - gap;
          if (top < margin) top = r.bottom + gap;
        } else {
          top = r.bottom + gap;
          if (top + mh > window.innerHeight - margin) top = r.top - mh - gap;
        }

        d.menu.style.left = `${Math.round(left)}px`;
        d.menu.style.top = `${Math.round(top)}px`;
        d.menu.style.right = "auto";
        d.menu.style.bottom = "auto";
        d.menu.style.minWidth = `${Math.round(r.width)}px`;
        d.menu.style.maxHeight = `${Math.max(120, window.innerHeight - margin * 2)}px`;
        d.menu.style.overflow = "auto";
      };

      const close = (kind) => {
        const d = DD[kind];
        if (!d) return;
        d.dd.classList.remove("open");
        d.menu.hidden = true;
        restoreMenu(kind);
        if (state.openKind === kind) state.openKind = null;
      };

      const closeAll = () => {
        if (state.openKind) close(state.openKind);
      };

      const open = (kind) => {
        const d = DD[kind];
        if (!d) return;
        closeAll();
        d.dd.__lrDDState?.buildMenu?.();
        d.dd.classList.add("open");
        d.menu.hidden = false;
        portalMenu(kind);
        positionMenu(kind);
        state.openKind = kind;
      };

      const toggle = (kind) => {
        if (state.openKind === kind) close(kind);
        else open(kind);
      };

      ["color", "font"].forEach((kind) => {
        const d = DD[kind];
        if (!d?.btn) return;
        if (d.dd && d.dd.__lrDDState) {
          d.dd.__lrDDState.onClose = () => {
            restoreMenu(kind);
            if (state.openKind === kind) state.openKind = null;
          };
        }
        if (d.btn.dataset.lrDdBound) return;
        d.btn.dataset.lrDdBound = "1";
        d.btn.addEventListener("click", (e) => {
          e.preventDefault();
          toggle(e.currentTarget.dataset.kind);
        });
        d.btn.addEventListener("touchstart", (e) => {
          e.preventDefault();
          toggle(e.currentTarget.dataset.kind);
        }, { passive: false });
      });

      const onDocPointer = (e) => {
        if (!state.openKind) return;
        const d = DD[state.openKind];
        if (!d) return;
        if (d.btn.contains(e.target) || d.menu.contains(e.target)) return;
        closeAll();
      };

      const onKey = (e) => {
        if (e.key !== "Escape") return;
        closeAll();
      };

      const onResize = () => {
        if (!state.openKind) return;
        positionMenu(state.openKind);
      };

      document.addEventListener("pointerdown", onDocPointer, true);
      document.addEventListener("touchstart", onDocPointer, { passive: true, capture: true });
      document.addEventListener("keydown", onKey);
      window.addEventListener("resize", onResize, { passive: true });
      window.addEventListener("orientationchange", onResize, { passive: true });
      window.visualViewport?.addEventListener("resize", onResize, { passive: true });
      window.visualViewport?.addEventListener("scroll", onResize, { passive: true });

      const cleanup = () => {
        closeAll();
        document.removeEventListener("pointerdown", onDocPointer, true);
        document.removeEventListener("touchstart", onDocPointer, { capture: true });
        document.removeEventListener("keydown", onKey);
        window.removeEventListener("resize", onResize);
        window.removeEventListener("orientationchange", onResize);
        window.visualViewport?.removeEventListener("resize", onResize);
        window.visualViewport?.removeEventListener("scroll", onResize);
        window.__lrDDManagerInstalled = false;
        window.__lrDDManagerCleanup = null;
      };
      window.__lrDDManagerCleanup = cleanup;
      return cleanup;
    }

    function fillSelects() {
      if (!selectsState.init) {
        selFont.innerHTML = (cfg.fonts || []).map(f => `<option value="${f.id}">${f.label}</option>`).join("");
        selColor.innerHTML = (cfg.colors || []).map(c => `<option value="${c.value}">${c.label}</option>`).join("");
        selectsState.init = true;
      }
      selFont.value = currentFont;
      selColor.value = currentColor;
      setCurrentColorVar();

      if (!fontDD && selFont) {
        fontDD = createDropUp(selFont, {
          renderLabel: (opt) => opt?.textContent || "",
          renderOption: (opt) => opt?.textContent || ""
        });
        fontDD.wrap.dataset.kind = "font";
      } else {
        fontDD?.update();
      }

      if (!colorDD && selColor) {
        colorDD = createDropUp(selColor, {
          renderLabel: (opt) => {
            const frag = document.createDocumentFragment();
            const sw = document.createElement("span");
            sw.className = "lr-swatch";
            if (opt?.value) sw.style.background = opt.value;
            const txt = document.createElement("span");
            txt.textContent = opt?.textContent || "";
            frag.append(sw, txt);
            return frag;
          },
          renderOption: (opt) => {
            const frag = document.createDocumentFragment();
            const sw = document.createElement("span");
            sw.className = "lr-swatch";
            if (opt?.value) sw.style.background = opt.value;
            const txt = document.createElement("span");
            txt.textContent = opt?.textContent || "";
            frag.append(sw, txt);
            return frag;
          }
        });
        colorDD.wrap.dataset.kind = "color";
      } else {
        colorDD?.update();
      }
    }

    function renderTargets() {
      $$(".lr-target", board).forEach(n => n.remove());
      targets.forEach((t) => {
        const el = document.createElement("div");
        el.className = "lr-target";
        el.dataset.posId = t.id;
        el.style.left = `${t.xPct}%`;
        el.style.top = `${t.yPct}%`;
        board.appendChild(el);
      });
      buildNeighbors(true);
      updateBaseAvailability();
    }

    function renderTiles() {
      $$(".lr-tile", board).forEach(n => n.remove());

      for (const [posId, data] of placements.entries()) {
        const t = targets.find(x => x.id === posId);
        if (!t) continue;

        const tile = document.createElement("div");
        tile.className = "lr-tile";
        tile.dataset.posId = posId;
        tile.style.left = `${t.xPct}%`;
        tile.style.top = `${t.yPct}%`;
        tile.style.color = currentColor;
        tile.style.transform = `translate(-50%,-50%) rotate(${data.rot}deg)`;

        const glyph = document.createElement("div");
        glyph.className = "lr-glyph";
        glyph.textContent = glyphLabel(data.ch);
        tile.appendChild(glyph);

        if (posId === selectedPos) tile.classList.add("selected");
        board.appendChild(tile);
      }

      if (rotateBox) rotateBox.hidden = true;
      trash?.classList.toggle("is-clickable", !!selectedPos);
      positionBoardControls();
      clearTargetHighlights(board);
      updateBaseAvailability();
    }

    function renderKeyboard() {
      keyboard.innerHTML = "";
      const rows = buildKeyboard("qwerty");
      rows.forEach((row) => {
        const rowEl = document.createElement("div");
        rowEl.className = "lr-kbRow";
        row.forEach((ch) => {
          const chN = normalizeCh(ch);
          const key = document.createElement("div");
          key.className = "lr-key";
          key.dataset.ch = chN;
          const glyph = document.createElement("div");
          glyph.className = "lr-glyph";
          glyph.textContent = glyphLabel(chN);
          key.appendChild(glyph);
          key.style.color = currentColor;
          rowEl.appendChild(key);
        });
        keyboard.appendChild(rowEl);
      });
      updateKeyboardArmedUI();
      syncKeySizeVar();
    }

    function renderAll() {
      fillSelects();
      renderTargets();
      ensureFlowerAnchor();
      renderFlower();
      renderTiles();
      renderKeyboard();
      updateStatusHint();
      positionBoardControls();
      clearTargetHighlights(board);
    }

    function updateStatusHint() { /* intentionally blank */ }

    function getNearestTarget(clientX, clientY) {
      const rect = board.getBoundingClientRect();
      const x = clientX - rect.left;
      const y = clientY - rect.top;

      const threshold = Math.max(18, rect.width * 0.035);
      const thr2 = threshold * threshold;

      let best = null;
      let bestD = Infinity;

      for (const t of targets) {
        const tx = (t.xPct / 100) * rect.width;
        const ty = (t.yPct / 100) * rect.height;
        const d = dist2(x, y, tx, ty);
        if (d < bestD) { bestD = d; best = t; }
      }

      if (best && bestD <= thr2) return best;
      return null;
    }

    // ===== neighbor + validity helpers =====
    function buildNeighbors(force=false) {
      neighborsMap.clear();
      if (!targets.length) return;
      const hash = `${board.clientWidth}|${board.clientHeight}|${targets.length}`;
      if (!force && neighborHash === hash && neighborsMap.size) return;
      neighborHash = hash;
      const pts = targets.map(t => ({ id: t.id, x: t.xPct / 100, y: t.yPct / 100 }));
      const dists = [];
      pts.forEach((p, i) => {
        let minD = Infinity;
        pts.forEach((q, j) => {
          if (i === j) return;
          const d = Math.hypot(p.x - q.x, p.y - q.y);
          if (d < minD) minD = d;
        });
        if (Number.isFinite(minD)) dists.push(minD);
      });
      const median = (arr) => {
        if (!arr.length) return 0;
        const s = arr.slice().sort((a,b)=>a-b);
        const m = Math.floor(s.length/2);
        return s.length %2 ? s[m] : (s[m-1]+s[m])/2;
      };
      const step = median(dists) || 1;
      const tolDiag = 0.6;
      pts.forEach(p => {
        const res = { UL:null, UR:null, DL:null, DR:null };
        pts.forEach(q => {
          if (p.id === q.id) return;
          const dx = q.x - p.x;
          const dy = q.y - p.y;
          const dist = Math.hypot(dx, dy);
          if (dist > step * 1.5) return;
          const adx = Math.abs(dx), ady = Math.abs(dy);
          const ratio = adx && ady ? adx/ady : 0;
          const assign = (k) => { if (!res[k] || dist < res[k].dist) res[k] = { id: q.id, dist }; };
          if (dx < 0 && dy < 0 && ratio > tolDiag && ratio < (1/tolDiag)) assign("UL");
          if (dx > 0 && dy < 0 && ratio > tolDiag && ratio < (1/tolDiag)) assign("UR");
          if (dx < 0 && dy > 0 && ratio > tolDiag && ratio < (1/tolDiag)) assign("DL");
          if (dx > 0 && dy > 0 && ratio > tolDiag && ratio < (1/tolDiag)) assign("DR");
        });
        neighborsMap.set(p.id, {
          UL: res.UL?.id || null,
          UR: res.UR?.id || null,
          DL: res.DL?.id || null,
          DR: res.DR?.id || null
        });
      });
      window.lrNeighbors = neighborsMap;
      renderFlower();
      updateBaseAvailability();
    }

    const debouncedBuildNeighbors = debounce(() => {
      if (!modal.classList.contains("is-open")) return;
      if (!targets.length) return;
      buildNeighbors(true);
    }, 150);

    const handleResize = () => {
      positionBoardControls();
      if (!modal.classList.contains("is-open")) return;
      debouncedBuildNeighbors();
    };

    window.addEventListener("resize", handleResize);

    if (window.ResizeObserver && board) {
      const ro = new ResizeObserver(() => {
        if (!modal.classList.contains("is-open")) return;
        debouncedBuildNeighbors();
        positionBoardControls();
      });
      ro.observe(board);
    }

    function getOccupiedSet(ignoreId=null, ignoreFlower=false) {
      const set = new Set();
      for (const [posId] of placements.entries()) {
        if (ignoreId && posId === ignoreId) continue;
        set.add(posId);
      }
      if (!ignoreFlower) {
        const fo = getFlowerOccupied(flower.anchorPosId);
        if (fo) fo.forEach(id => set.add(id));
      }
      return set;
    }

    function isValidPlacement(posId, occupied) {
      if (!posId) return false;
      if (!occupied) occupied = getOccupiedSet();
      if (occupied.has(posId)) return false;
      const n = neighborsMap.get(posId) || {};
      const diag = [n.UL, n.UR, n.DL, n.DR].filter(Boolean);
      return !diag.some(d => occupied.has(d));
    }

    function highlightTarget(target, occupied) {
      clearTargetHighlights(board);
      if (!target) return;
      const el = board.querySelector(`.lr-target[data-pos-id="${target.id}"]`);
      const blockers = [];
      if (occupied.has(target.id)) blockers.push(target.id);
      const neigh = neighborsMap.get(target.id) || {};
      ["UL","UR","DL","DR"].forEach(k => {
        const nId = neigh[k];
        if (nId && occupied.has(nId)) blockers.push(nId);
      });
      const ok = blockers.length === 0;
      if (el) el.classList.add(ok ? "lr-target--ok" : "lr-target--bad");
      blockers.forEach(id => {
        const tEl = board.querySelector(`.lr-target[data-pos-id="${id}"]`);
        if (tEl) tEl.classList.add("lr-target--blocker");
        const tileEl = board.querySelector(`.lr-tile[data-pos-id="${id}"]`);
        if (tileEl) tileEl.classList.add("lr-tile--blocker");
      });
      if (window && window.console) {
        console.log("hover target", target.id, "blockers", blockers, "neighbors", neigh);
      }
    }

    // ===== Flower helpers =====
    function getFlowerOccupied(anchorPosId) {
      if (!anchorPosId) return null;
      const n = neighborsMap.get(anchorPosId) || {};
      const dl = n.DL;
      const dr = n.DR;
      const dd = dl ? (neighborsMap.get(dl) || {}).DR : null;
      if (!dl || !dr || !dd) return null;
      return [anchorPosId, dl, dr, dd];
    }

    function getFlowerOccSet(ignore=false) {
      if (!flower.anchorPosId || ignore) return new Set();
      const occ = getFlowerOccupied(flower.anchorPosId);
      return new Set(occ || []);
    }

    function canPlaceFlower(anchorPosId) {
      const occ = getFlowerOccupied(anchorPosId);
      if (!occ) return { ok:false, occ:null, blockers:[] };
      const occSet = new Set(occ);
      const blockers = [];
      const tileOcc = getOccupiedSet(null, true); // ignore current flower
      occSet.forEach(id => { if (tileOcc.has(id)) blockers.push(id); });
      occSet.forEach(id => {
        const neigh = neighborsMap.get(id) || {};
        ["UL","UR","DL","DR"].forEach(k => {
          const nId = neigh[k];
          if (nId && tileOcc.has(nId) && !occSet.has(nId)) blockers.push(nId);
        });
      });
      return { ok: blockers.length === 0, occ, blockers };
    }

    function highlightFlowerPreview(occ, blockers) {
      clearTargetHighlights(board);
      if (!occ || !occ.length) return;
      const ok = !blockers || !blockers.length;
      occ.forEach(id => {
        const el = board.querySelector(`.lr-target[data-pos-id="${id}"]`);
        if (el) el.classList.add(ok ? "lr-target--ok" : "lr-target--bad");
      });
      (blockers || []).forEach(id => {
        const el = board.querySelector(`.lr-target[data-pos-id="${id}"]`);
        if (el) el.classList.add("lr-target--blocker");
        const tileEl = board.querySelector(`.lr-tile[data-pos-id="${id}"]`);
        if (tileEl) tileEl.classList.add("lr-tile--blocker");
      });
    }

    function pickDefaultFlowerAnchor() {
      const preferredId = "r03c07";
      const prefOk = preferredId && getFlowerOccupied(preferredId);
      if (prefOk) return preferredId;
      const preferred = { nx:0.5, ny:0.35 };
      let best = null, bestD = Infinity;
      targets.forEach(t => {
        const occ = getFlowerOccupied(t.id);
        if (!occ) return;
        const c = getTargetCenterNorm(t.id);
        if (!c) return;
        const d = Math.hypot(c.nx - preferred.nx, c.ny - preferred.ny);
        if (d < bestD) { bestD = d; best = t.id; }
      });
      if (!best) {
        const alt = targets.find(t => getFlowerOccupied(t.id));
        return alt ? alt.id : null;
      }
      return best;
    }

    function renderFlower(anchorOverride=null) {
      const el = flowerEl;
      const anchor = anchorOverride != null ? anchorOverride : flower.anchorPosId;
      if (!anchor) { el.style.display = "none"; return; }
      const occ = getFlowerOccupied(anchor);
      if (!occ) { el.style.display = "none"; return; }
      const pts = occ.map(getTargetCenterNorm).filter(Boolean);
      if (pts.length !== occ.length) { el.style.display = "none"; return; }
      const cx = pts.reduce((a,p)=>a+p.nx,0)/pts.length;
      const cy = pts.reduce((a,p)=>a+p.ny,0)/pts.length;
      el.style.display = "";
      el.style.left = `${(cx*100).toFixed(4)}%`;
      el.style.top  = `${(cy*100).toFixed(4)}%`;
      el.dataset.anchorPosId = anchor;
      const imgUrl = (cfg.bgUrl || "").replace("love-rock-bg.png", "love-rock-bg-flower.png");
      if (imgUrl) {
        el.style.setProperty("--lr-flower-img", `url(${imgUrl})`);
      } else {
        el.style.removeProperty("--lr-flower-img");
      }
      updateBaseAvailability();
    }

    function ensureFlowerAnchor() {
      const prev = flower.anchorPosId;
      if (!flower.anchorPosId || !getFlowerOccupied(flower.anchorPosId)) {
        flower.anchorPosId = pickDefaultFlowerAnchor();
      }
      renderFlower();
      if (flower.anchorPosId !== prev) scheduleDraftPersist();
    }

    function findNearestTargetByPct(px, py) {
      let best = null, bestD = Infinity;
      targets.forEach(t => {
        const dx = t.xPct - px;
        const dy = t.yPct - py;
        const d = dx*dx + dy*dy;
        if (d < bestD) { bestD = d; best = t; }
      });
      return best;
    }

    window.lrDiagDebug = (posId) => {
      const n = neighborsMap.get(posId) || {};
      console.log({ posId, neighbors: n, occupied: Array.from(getOccupiedSet()) });
    };
    window.lrFlowerDebug = () => {
      console.log({ anchor: flower.anchorPosId, occ: getFlowerOccupied(flower.anchorPosId) });
    };
    function highlightHover(target) {
      const ignoreId = (dragging && dragging.type === "tile") ? dragging.fromPos : null;
      const occupied = getOccupiedSet(ignoreId);
      if (!target) { clearTargetHighlights(board); return; }
      highlightTarget(target, occupied);
    }

    function setSelected(posId, { toggle=true, force=false } = {}) {
      if (force) {
        selectedPos = posId;
      } else if (toggle && selectedPos === posId) {
        selectedPos = null;
      } else {
        selectedPos = posId;
      }
      setFlowerSelected(false, { silent: true });
      armedKeyCh = null;
      updateKeyboardArmedUI();
      renderTiles();
    }

    function setFlowerSelected(on, { silent=false } = {}) {
      const next = !!on;
      selectedFlower = next;
      if (flowerEl) flowerEl.classList.toggle("is-selected", next);
      if (next) {
        selectedPos = null;
        armedKeyCh = null;
        updateKeyboardArmedUI();
      }
      if (!next) {
        selectedFlower = false;
      }
      if (!silent) renderTiles();
    }

    function placeAt(posId, ch, rot) {
      ch = normalizeCh(ch);
      const hasExisting = placements.has(posId);
      if (!hasExisting && cfg.maxTiles && placements.size >= cfg.maxTiles) {
        setStatus(`Maximaal ${cfg.maxTiles} tekens.`);
        return;
      }
      placements.set(posId, { ch, rot: clampRot(rot) });
      setSelected(posId);
      updateStatusHint();
      scheduleDraftPersist();
    }

    function removeAt(posId) {
      placements.delete(posId);
      if (selectedPos === posId) selectedPos = null;
      renderTiles();
      updateStatusHint();
      clearTargetHighlights(board);
      scheduleDraftPersist();
    }

    function buildOutputText() {
      // Leesvolgorde = targets array volgorde
      let out = "";
      for (const t of targets) {
        const p = placements.get(t.id);
        if (p) out += p.ch;
      }
      return out;
    }

    function updateInputsFromState() {
      inputText.value = buildOutputText();
      inputPretty.value = buildOutputTextPretty();
      inputFont.value = currentFont;
      inputColor.value = currentColor;
      inputDesignId.value = currentDesignId || "";
    }

    function prettyToken(ch) {
      if (ch === " ") return "␠";
      return ch;
    }

    function buildOutputTextPretty() {
      const parts = [];
      for (const t of targets) {
        const p = placements.get(t.id);
        if (p) parts.push(prettyToken(p.ch));
      }
      return parts.join(" - ");
    }

    function clearDraftStorage() {
      const lastKey = `lr:last:${cfg.productHandle}`;
      const lastId = safeGetItem(lastKey);
      if (lastId) safeRemoveItem(`lr:design:${lastId}`);
      if (currentDesignId && currentDesignId !== lastId) {
        safeRemoveItem(`lr:design:${currentDesignId}`);
      }
      safeRemoveItem(lastKey);
    }

    function finalizeDraftAfterAdd(finalId) {
      const lastKey = `lr:last:${cfg.productHandle}`;
      if (finalId) safeRemoveItem(`lr:design:${finalId}`);
      safeRemoveItem(lastKey);
      currentDesignId = null;
      placements.clear();
      flower.anchorPosId = null;
      selectedPos = null;
      selectedFlower = false;
    }

    let isFinalizing = false;
    function persistDraft() {
      if (isFinalizing) return;
      const isEmpty = placements.size === 0 && !flower.anchorPosId;
      if (isEmpty) {
        clearDraftStorage();
        currentDesignId = null;
        updateInputsFromState();
        return;
      }

      if (!currentDesignId) currentDesignId = newDesignId();

      const savedAt = Date.now();
      const payload = {
        version: 1,
        savedAt,
        expiresAt: savedAt + DRAFT_TTL_MS,
        design_id: currentDesignId,
        font: currentFont,
        color: currentColor,
        flower: { anchorPosId: flower.anchorPosId || null },
        placements: Array.from(placements.entries()).map(([pos, v]) => ({ pos, ch: v.ch, rot: v.rot }))
      };

      safeSetItem(`lr:design:${currentDesignId}`, JSON.stringify(payload));
      safeSetItem(`lr:last:${cfg.productHandle}`, currentDesignId);
      updateInputsFromState();
    }

    const scheduleDraftPersist = debounce(persistDraft, 300);

    function restoreLastDraft() {
      const lastKey = `lr:last:${cfg.productHandle}`;
      const lastId = safeGetItem(lastKey);
      if (!lastId) return false;

      const raw = safeGetItem(`lr:design:${lastId}`);
      if (!raw) return false;

      let payload = null;
      try { payload = JSON.parse(raw); } catch { return false; }
      if (!payload || typeof payload !== "object") return false;

      const now = Date.now();
      if (typeof payload.expiresAt === "number" && payload.expiresAt < now) {
        safeRemoveItem(`lr:design:${lastId}`);
        safeRemoveItem(lastKey);
        return false;
      }

      if (typeof payload.savedAt !== "number" || typeof payload.expiresAt !== "number") {
        const savedAt = typeof payload.savedAt === "number" ? payload.savedAt : now;
        payload.savedAt = savedAt;
        payload.expiresAt = savedAt + DRAFT_TTL_MS;
        safeSetItem(`lr:design:${lastId}`, JSON.stringify(payload));
      }

      currentDesignId = payload.design_id || lastId;
      if (payload.font) currentFont = payload.font;
      lrApplyFont(currentFont, cfg, uiState);
      currentFont = uiState.font;

      if (payload.color) currentColor = payload.color;
      setCurrentColorVar();

      if (payload.flower && "anchorPosId" in payload.flower) {
        flower.anchorPosId = payload.flower.anchorPosId || null;
      }

      placements.clear();
      if (Array.isArray(payload.placements)) {
        for (const p of payload.placements) {
          if (!p || !p.pos || typeof p.ch !== "string") continue;
          if (!getTargetByPosId(p.pos)) continue;
          placements.set(p.pos, { ch: normalizeCh(p.ch), rot: clampRot(p.rot) });
        }
      }

      selectedPos = null;
      selectedFlower = false;
      updateInputsFromState();
      return true;
    }

    function saveToStorageAndInputs(closeAfter=true) {
      if (placements.size < cfg.minTiles) {
        setStatus(`Minimaal ${cfg.minTiles} tegels. Anders niet.`);
        return false;
      }

      if (!currentDesignId) currentDesignId = newDesignId();

      const savedAt = Date.now();
      const payload = {
        version: 1,
        savedAt,
        expiresAt: savedAt + DRAFT_TTL_MS,
        design_id: currentDesignId,
        font: currentFont,
        color: currentColor,
        flower: { anchorPosId: flower.anchorPosId || null },
        placements: Array.from(placements.entries()).map(([pos, v]) => ({ pos, ch: v.ch, rot: v.rot }))
      };

      safeSetItem(`lr:design:${currentDesignId}`, JSON.stringify(payload));
      safeSetItem(`lr:last:${cfg.productHandle}`, currentDesignId);

      updateInputsFromState();

      setStatus("Opgeslagen.");
      if (closeAfter) closeModal();
      return true;
    }

    // ====== drag ghost ======
    function startGhost(ch, clientX, clientY) {
      ghost = document.createElement("div");
      ghost.className = "lr-ghost";
      ghost.style.color = currentColor;

      const g = document.createElement("div");
      g.className = "lr-glyph";
      g.textContent = glyphLabel(ch);
      ghost.appendChild(g);
      patchGhostFonts(ghost);

      document.body.appendChild(ghost);
      moveGhost(clientX, clientY);
    }

    function moveGhost(x, y) {
      if (!ghost) return;
      const half = tileHalfPx();
      ghost.style.transform = `translate(${x - half}px, ${y - half}px)`;
    }

    // ===== events =====
    btnOpen.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openModal();
      },
      true
    );
    $$("[data-lr-close]", modal).forEach(el => el.addEventListener("click", closeModal));

    btnSave.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (btnSave.dataset.busy === "1") return;
      btnSave.dataset.busy = "1";
      btnSave.disabled = true;

      const ok = saveToStorageAndInputs(false);
      if (!ok) {
        btnSave.dataset.busy = "0";
        btnSave.disabled = false;
        return;
      }

      try {
        const fd = new FormData(form);
        const res = await fetch("/cart/add.js", {
          method: "POST",
          body: fd,
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        if (!res.ok) throw new Error("Add to cart failed");

        const finalId = inputDesignId.value || currentDesignId;
        isFinalizing = true;
        finalizeDraftAfterAdd(finalId);
        location.href = "/cart";
      } catch {
        btnSave.dataset.busy = "0";
        btnSave.disabled = false;
      }
    });

    function runReset() {
      placements.clear();
      selectedPos = null;
      currentDesignId = null;
      setArmedKey(null, { toggle: false });
      // send flower to fixed stud r03c07 if available
      const resetAnchor = targets.find(t => t.id === "r03c07") ? "r03c07" : null;
      flower.anchorPosId = resetAnchor;
      setFlowerSelected(false);
      renderFlower();
      renderTiles();
      updateStatusHint();
      setStatus("Leeg. Begin opnieuw.");
      scheduleDraftPersist();
    }

    btnReset.addEventListener("click", () => {
      if (!resetConfirmEl || resetConfirmEl.hidden) showResetConfirm();
      else hideResetConfirm();
    });
    modal.addEventListener("pointerdown", (e) => {
      const inBoard = e.target.closest("#lr-board");
      const inKeyboard = e.target.closest("#lr-keyboard");
      const inTrash = e.target.closest("#lr-trash");
      if (!inBoard && !inKeyboard && !inTrash) clearAllSelection();
    }, true);

    selFont.addEventListener("change", () => {
      currentFont = selFont.value;
      lrApplyFont(currentFont, cfg, uiState);
      updateStatusHint();
      scheduleDraftPersist();
    });
    selColor.addEventListener("change", () => {
      currentColor = selColor.value;
      setCurrentColorVar();
      renderTiles();
      renderKeyboard();
      updateStatusHint();
      scheduleDraftPersist();
    });

    // select & drag existing tile
    board.addEventListener("pointerdown", (e) => {
      if (armedKeyCh) {
        const tileHit = e.target.closest(".lr-tile");
        const flowerHit = e.target.closest("#lr-flower");
        if (!tileHit && !flowerHit) {
          const t = getNearestTarget(e.clientX, e.clientY);
          if (t) {
            const ok = isValidPlacement(t.id, getOccupiedSet());
            highlightTarget(t, getOccupiedSet());
            if (ok) {
              placeAt(t.id, armedKeyCh, randomRot());
              setArmedKey(null, { toggle: false });
              clearTargetHighlights(board);
              return;
            }
          }
          return;
        }
      }

      const tile = e.target.closest(".lr-tile");
      if (!tile) return;

      const posId = tile.dataset.posId;
      dragType = "tile";
      dragFromPosId = posId;
      setSelected(posId);

      dragging = {
        type: "tile",
        fromPos: posId,
        ch: placements.get(posId)?.ch,
        rot: placements.get(posId)?.rot,
        startX: e.clientX,
        startY: e.clientY,
        moved: false
      };

      board.setPointerCapture(e.pointerId);
    });

    if (flowerEl) {
      flowerEl.addEventListener("pointerdown", (e) => {
        if (!flower.anchorPosId) ensureFlowerAnchor();
        setFlowerSelected(!selectedFlower);
        dragType = "flower";
        dragging = {
          type: "flower",
          startX: e.clientX,
          startY: e.clientY,
          moved: false,
          candidate: flower.anchorPosId
        };
        e.preventDefault();
      });
    }

    board.addEventListener("pointermove", (e) => {
      if (!dragging) return;

      const dx = e.clientX - dragging.startX;
      const dy = e.clientY - dragging.startY;

      if (!dragging.moved && (Math.abs(dx) + Math.abs(dy) > 6)) {
        dragging.moved = true;
        if (dragging.type === "tile") {
          setSelected(dragging.fromPos, { toggle: false, force: true });
        } else if (dragging.type === "flower") {
          setFlowerSelected(true);
        }
        board.classList.add("is-dragging");
        if (dragging.type !== "flower") {
          startGhost(dragging.ch, e.clientX, e.clientY);
        }
        updateBaseAvailability();
      }
      if (!dragging.moved) return;

      if (dragging.type === "flower") {
        const t = getNearestTarget(e.clientX, e.clientY);
        dragging.candidate = t?.id || null;
        const res = t ? canPlaceFlower(t.id) : { ok:false, occ:null, blockers:[] };
        if (t && res.occ) renderFlower(t.id);
        highlightFlowerPreview(res.occ || [], res.blockers || []);
      } else {
        moveGhost(e.clientX, e.clientY);
        highlightHover(getNearestTarget(e.clientX, e.clientY));
      }
    });

    board.addEventListener("pointerup", (e) => {
      if (!dragging) return;

      const wasMoved = dragging.moved;
      const type = dragging.type;

      if (!wasMoved) { clearDrag(); return; }

      const trashRect = trash.getBoundingClientRect();
      if (inRect(e.clientX, e.clientY, trashRect) && type === "tile") {
        removeAt(dragging.fromPos);
        clearDrag();
        return;
      }

      // EXTRA: drop on keyboard area = delete
      if (type === "tile" && isDropOnKeyboardArea(e.clientX, e.clientY)) {
        removeAt(dragging.fromPos);
        clearDrag();
        return;
      }

      // FAILSAFE: clearly to the right of the board = delete
      if (type === "tile") {
        const br = board.getBoundingClientRect();
        const rightThreshold = 24;
        if (e.clientX > br.right + rightThreshold) {
          removeAt(dragging.fromPos);
          clearDrag();
          return;
        }
      }

      if (type === "flower") {
        const candidate = dragging.candidate || flower.anchorPosId;
        const res = candidate ? canPlaceFlower(candidate) : { ok:false };
        if (res.ok && candidate) {
          flower.anchorPosId = candidate;
          setFlowerSelected(true);
          scheduleDraftPersist();
        } else {
          renderFlower();
        }
        clearDrag();
        return;
      }

      const t = getNearestTarget(e.clientX, e.clientY);
      if (t) {
        const ignoreId = (type === "tile") ? dragging.fromPos : null;
        const occupied = getOccupiedSet(ignoreId);
        const ok = isValidPlacement(t.id, occupied);
        highlightTarget(t, occupied);
        if (ok) {
          if (type === "tile") {
            removeAt(dragging.fromPos);
            placeAt(t.id, dragging.ch, dragging.rot);
          } else if (type === "key") {
            placeAt(t.id, dragging.ch, randomRot());
          }
        } else {
          if (type === "tile") setSelected(dragging.fromPos);
        }
      } else {
        if (type === "tile") setSelected(dragging.fromPos);
      }

      clearDrag();
    });
    board.addEventListener("pointercancel", () => {
      clearDrag();
      setArmedKey(null, { toggle: false });
      updateBaseAvailability();
    });

    // keyboard drag
    keyboard.addEventListener("pointerdown", (e) => {
      const key = e.target.closest(".lr-key");
      if (!key) return;

      if (!targets.length) {
        setStatus("Geen targets. Zet ?lr_debug=1 en run Auto-grid wizard.");
        return;
      }

      const ch = key.dataset.ch;
      dragType = "key";
      dragFromPosId = null;
      dragging = { type: "key", ch, keyEl: key, startX: e.clientX, startY: e.clientY, moved: false };
      keyboard.setPointerCapture(e.pointerId);
    });

    keyboard.addEventListener("pointermove", (e) => {
      if (!dragging || dragging.type !== "key") return;
      if (!dragging.moved) {
        const dx = Math.abs(e.clientX - dragging.startX);
        const dy = Math.abs(e.clientY - dragging.startY);
        if ((dx + dy) > 6) {
          dragging.moved = true;
          setArmedKey(null, { toggle: false });
          board.classList.add("is-dragging");
          startGhost(dragging.ch, e.clientX, e.clientY);
          updateBaseAvailability();
        }
      }
      if (!dragging.moved) return;
      moveGhost(e.clientX, e.clientY);
      highlightHover(getNearestTarget(e.clientX, e.clientY));
    });

    keyboard.addEventListener("pointerup", (e) => {
      if (!dragging || dragging.type !== "key") return;
      if (!dragging.moved) {
        setArmedKey(dragging.ch);
        clearDrag();
        return;
      }
      const t = getNearestTarget(e.clientX, e.clientY);
      if (t) {
        const ok = isValidPlacement(t.id, getOccupiedSet());
        highlightTarget(t, getOccupiedSet());
        if (ok) placeAt(t.id, dragging.ch, randomRot());
      }
      clearDrag();
      setArmedKey(null, { toggle: false });
    });
    keyboard.addEventListener("pointercancel", () => {
      clearDrag();
      setArmedKey(null, { toggle: false });
    });

    // rotate selected
    function rotateSelected(delta) {
      if (!selectedPos) return;
      const p = placements.get(selectedPos);
      if (!p) return;

      const idx = ROT_STEPS.indexOf(p.rot);
      const nextIdx = (idx + delta + ROT_STEPS.length) % ROT_STEPS.length;
      p.rot = ROT_STEPS[nextIdx];
      placements.set(selectedPos, p);
      renderTiles();
      scheduleDraftPersist();
    }
    rotL.addEventListener("click", (e) => { e.preventDefault(); });
    rotR.addEventListener("click", (e) => { e.preventDefault(); });
    trash.addEventListener("click", () => {
      if (selectedFlower) {
        flower.anchorPosId = null;
        setFlowerSelected(false);
        renderFlower();
        clearTargetHighlights(board);
        scheduleDraftPersist();
        return;
      }
      if (!selectedPos) return;
      removeAt(selectedPos);
      selectedPos = null;
      renderTiles();
      updateStatusHint();
    });

    // gate add-to-cart
    form.addEventListener("submit", (e) => {
      if (modal.classList.contains("is-open")) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (placements.size < cfg.minTiles) {
        e.preventDefault();
        openModal();
        setStatus(`Eerst minimaal ${cfg.minTiles} tegels plaatsen.`);
        return;
      }
      saveToStorageAndInputs(false);
    });

    // ======= DEBUG: Auto-grid wizard (2 clicks) =======
    let img = null;
    let imgCanvas = null;
    let imgCtx = null;

    function ensureImageLoaded() {
      return new Promise((resolve, reject) => {
        if (img && img.complete) return resolve();

        img = new Image();
        img.crossOrigin = "anonymous"; // meestal ok op Shopify assets
        img.onload = () => {
          imgCanvas = document.createElement("canvas");
          imgCanvas.width = img.naturalWidth;
          imgCanvas.height = img.naturalHeight;
          imgCtx = imgCanvas.getContext("2d", { willReadFrequently: true });
          imgCtx.drawImage(img, 0, 0);
          resolve();
        };
        img.onerror = reject;
        img.src = cfg.bgUrl;
      });
    }

    function samplePixel(px, py) {
      if (!imgCtx) return null;
      const x = Math.max(0, Math.min(imgCanvas.width - 1, Math.round(px)));
      const y = Math.max(0, Math.min(imgCanvas.height - 1, Math.round(py)));
      const d = imgCtx.getImageData(x, y, 1, 1).data;
      return { r: d[0], g: d[1], b: d[2], a: d[3] };
    }

    function sortReadingOrder(list) {
      // simpele leesvolgorde: top->bottom, links->rechts
      return list.sort((a,b) => (a.yPct - b.yPct) || (a.xPct - b.xPct));
    }

    if (debug) {
      let wizardActive = false;
      let click1 = null;
      let click2 = null;

      const help = (t) => { if (debugHelp) debugHelp.textContent = t || ""; };

      btnAutoStart.addEventListener("click", async () => {
        await ensureImageLoaded();
        wizardActive = true;
        click1 = null;
        click2 = null;
        help("Klik 2 studs die naast elkaar liggen (op het roze hart). Eerst stud A, daarna de buur-stud B.");
        setStatus("Wizard actief: klik 2 studs.");
      });

      board.addEventListener("click", async (e) => {
        if (!wizardActive) return;
        await ensureImageLoaded();

        const boardRect = board.getBoundingClientRect();
        const drawRect = getDrawRect(boardRect, img.naturalWidth, img.naturalHeight);
        const pt = boardPointToImagePx(boardRect, drawRect, img.naturalWidth, img.naturalHeight, e.clientX, e.clientY);
        if (!pt) return;

        const px = samplePixel(pt.px, pt.py);
        if (!px || !isOnPinkHeart(px.r, px.g, px.b, px.a)) {
          setStatus("Die klik was niet op het roze hart. Klik op een stud op het hart.");
          return;
        }

        if (!click1) {
          click1 = pt;
          help("Top. Klik nu een DIRECT aangrenzende stud (buur) in dezelfde rij/lijn.");
          setStatus("Klik 2/2: buur-stud.");
          return;
        }

        click2 = pt;
        wizardActive = false;

        // vector = grid step
        const vx = click2.px - click1.px;
        const vy = click2.py - click1.py;
        const step = Math.hypot(vx, vy);
        if (step < 10) {
          setStatus("Te dichtbij. Klik echt twee verschillende studs.");
          return;
        }

        const ax = vx / step;
        const ay = vy / step;
        const bx = -ay;
        const by = ax;

        // generate full grid around anchor
        const maxN = Math.ceil((Math.max(img.naturalWidth, img.naturalHeight) / step) * 1.2);

        const pts = [];
        const anchorParity = 0; // (0,0)

        for (let i = -maxN; i <= maxN; i++) {
          for (let j = -maxN; j <= maxN; j++) {
            // checkerboard: alleen 1 parity (dit is de “geldige studs” truc)
            const parity = (i + j) & 1;
            if (parity !== anchorParity) continue;

            const pxX = click1.px + i * step * ax + j * step * bx;
            const pxY = click1.py + i * step * ay + j * step * by;

            if (pxX < 0 || pxY < 0 || pxX > img.naturalWidth || pxY > img.naturalHeight) continue;

            const pix = samplePixel(pxX, pxY);
            if (!pix) continue;
            if (!isOnPinkHeart(pix.r, pix.g, pix.b, pix.a)) continue;

            const { xPct, yPct } = imagePxToBoardPct(boardRect, drawRect, img.naturalWidth, img.naturalHeight, pxX, pxY);
            pts.push({ id: "", xPct: +xPct.toFixed(4), yPct: +yPct.toFixed(4) });
          }
        }

        // de-dupe (rond op 2 decimalen) zodat je niet 2x dezelfde krijgt
        const seen = new Set();
        const dedup = [];
        for (const p of pts) {
          const k = `${p.xPct.toFixed(2)}|${p.yPct.toFixed(2)}`;
          if (seen.has(k)) continue;
          seen.add(k);
          dedup.push(p);
        }

        sortReadingOrder(dedup);

        // id’s zetten
        dedup.forEach((p, idx) => p.id = `p${String(idx + 1).padStart(4, "0")}`);

        targets = dedup;
        safeSetItem(targetsKey, JSON.stringify(targets));

        placements.clear();
        selectedPos = null;

        renderAll();
        setStatus(`Auto-grid klaar: ${targets.length} targets. Test maar.`);
        help("Auto-grid klaar. Je kunt nu slepen. Export JSON is optioneel.");
      });

      btnExportTargets.addEventListener("click", async () => {
        const json = JSON.stringify(targets, null, 2);
        exportBox.value = json;
        try { await navigator.clipboard.writeText(json); setStatus("Targets JSON gekopieerd."); }
        catch { setStatus("Targets JSON staat in textbox."); }
      });

      btnClearTargets.addEventListener("click", () => {
        if (!confirm("Targets wissen?")) return;
        targets = [];
        safeRemoveItem(targetsKey);
        placements.clear();
        selectedPos = null;
        renderAll();
        setStatus("Targets gewist.");
        help("");
      });
    }

    // init
    const initialFont = (() => {
      const hasSaved = (cfg.fonts || []).some(f => f.id === currentFont);
      if (hasSaved) return currentFont;
      return cfg.fonts?.[0]?.id ?? "lilitaone";
    })();
    lrApplyFont(initialFont, cfg, uiState);
    currentFont = uiState.font;
    fillSelects();
    renderAll();
  }

  document.addEventListener("DOMContentLoaded", () => {
    try { main(); } catch (e) { console.error(e); }
    setupLoveRockActionsObserver();
    (async () => {
      const cfg = JSON.parse(document.getElementById('lr-config').textContent);
      const img = await new Promise(res => { const i=new Image(); i.onload=()=>res(i); i.src=cfg.bgUrl; });
      document.querySelector('#lr-board').style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
      positionBoardControls();
    })();
  });
})();
